import { CardInfoTranslation } from "@models/card-info-translation.model";
import { useLocation, useNavigate } from "react-router-dom";

export default function CardInfo(props: { data: CardInfoTranslation }) {
    const navigate = useNavigate();
    const location = useLocation();

    if (!props) return null
    const { id, title, cardInfo } = props.data
    const children = cardInfo?.children ?? []; 

    function goTo() {    
        if(children.length == 0){
            navigate(`/${location.pathname.split("/")[1]}/NoChildPage`)
        }else if (!children || children.length === 0 || children[0].type === "CARD_INFO") {
            navigate(`${location.pathname}/${cardInfo?.id}`);
            return;
        } else {
            //da fixare quando hai una card con 
            navigate(`${location.pathname}/${cardInfo?.id}/${children[0].id}`);
        }
    }

    return (
        <div
            role="button"
            className="d-flex flex-column justify-content-center align-items-center p-1 w-100"
            onClick={() => goTo()}
        >
            <div className="card-info">
                <img
                    src={`data:image/png;base64,${cardInfo?.photo}`}
                    alt="immagine"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",  
                        objectPosition: "center",
                        display: "block"
                    }}
                />
            </div>
            <span className="title-card-info">
                {title}
            </span>
        </div>
    )
}